var _TableCellCustom;
import * as React from 'react';
import { get } from 'lodash';
import { TableHead, TableRow } from '@lumahealthhq/ui-core';
import { useOrderContext } from '../../contexts/OrderContext';
import { removePropFromComponent } from '../../utils';
import CheckboxCell from '../CheckboxCell';
import TableCellCustom from '../TableCellCustom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const renderHeaders = (children, withCheckbox, getTableSortProps) => {
  return React.Children.map(children, (child, idx) => {
    const isValidChild = /*#__PURE__*/React.isValidElement(child);
    if (isValidChild) {
      const dataIndex = get(child, 'props.dataIndex', '');
      const isSortable = get(child, 'props.isSortable');
      const childWithoutRenderProp = removePropFromComponent(child, 'render', 'tableCellProps');
      const isFirstElement = withCheckbox ? false : idx === 0;
      const customProps = isSortable ? {
        isFirstElement,
        _sortProps: getTableSortProps(dataIndex)
      } : {};
      return /*#__PURE__*/React.cloneElement(childWithoutRenderProp, customProps);
    }
    return child;
  });
};
/**
 * @ignore - internal component.
 */
function TableHeaders({
  children,
  withCheckbox
}) {
  const {
    getTableSortProps
  } = useOrderContext();
  const renderedHeaders = React.useMemo(() => renderHeaders(children, !!withCheckbox, getTableSortProps), [children, withCheckbox, getTableSortProps]);
  if (!renderedHeaders) {
    return null;
  }
  return /*#__PURE__*/_jsx(TableHead, {
    children: /*#__PURE__*/_jsxs(TableRow, {
      sx: theme => ({
        height: '57px',
        '& > th': {
          borderColor: theme.palette.background.default
        }
      }),
      children: [withCheckbox && (_TableCellCustom || (_TableCellCustom = /*#__PURE__*/_jsx(TableCellCustom, {
        isFirstElement: true,
        isCheckbox: true,
        isHeader: true,
        children: /*#__PURE__*/_jsx(CheckboxCell, {
          isHeader: true
        })
      }))), renderedHeaders]
    })
  });
}
export default TableHeaders;